import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useForm, useWatch } from 'react-hook-form';
import FieldsDatePicker from '../../../../../@casino/ui/Fields/DatePicker';
import FieldInput from '../../../../../@casino/ui/Fields/Input';
import FieldTextarea from '../../../../../@casino/ui/Fields/Textarea';
import { useDispatch } from 'react-redux';
import { setPostMailing } from '../../../../store/mailing/thunk/setPostMailing';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';
import { setPostTags } from '../../store/thunk/setPostTags';

const useStyles = makeStyles(() => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(0,0,0,0.2)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    form: {
        background: '#1c2542',
        borderRadius: 8,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        rowGap: '12px',
        minWidth: 500
    },
    field: {
        padding: 10,
        paddingLeft: 10,
        border: '1px solid #141b33',
        outline: 'none',
        margin: 10,
        color: '#000',
        width: 'calc(100% - 40px)',
        '&::placeholder': {
            color: '#000'
        }
    },
    btn: {
        padding: '8px 14px',
        borderRadius: 4,
        background: 'gold',
        color: '#000',
        cursor: 'pointer',
        border: 'none',
        fontSize: 18
    },
    btn_disabled: {
        padding: '8px 13px',
        borderRadius: 4,
        background: 'none',
        color: '#ACACAC',
        border: '1px solid gold',
        cursor: 'pointer',
        fontSize: 18
    }
}))

const ModalAddTag = ({
    handleChangeMode,
    user_id
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        register,
        control,
        handleSubmit,
        reset
    } = useForm({
        defaultValues: {
            count_days: ""
        }
    })

    const onSubmit = (store) => {
        dispatch(setPostTags({
            ...store,
            user_id
        }, handleCancel));
    }

    const [tag] = useWatch({
        control,
        name: ['tag']
    });

    const handleCancel = () => {
        handleChangeMode();
        reset({})
    }

    const isValid = !tag

    return (
        <div className={classes.root}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div style={{display: 'flex', flexDirection: 'column', rowGap: 12}}>
                    <FieldInput
                        name="tag"
                        placeholder="Введите новый тег"
                        register={register}
                    />
                </div>
                <div style={{ display: 'flex', columnGap: 12, justifyContent: 'flex-end' }}>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className={classes.btn_disabled}
                    >
                        Отменить
                    </button>
                    <button
                        type="submit"
                        disabled={isValid}
                        className={!isValid ? classes.btn : classes.btn_disabled}
                    >
                        Создать
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ModalAddTag;